module.exports = __webpack_public_path__ + "media/game-video.e5fcc476.mp4";